// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"753":"72b8b50c","755":"fc8eecfb"}[chunkId] + ".chunk.js";
};